export default __webpack_public_path__ + "static/media/login.d4f44482.mp3";